import React from 'react';
import { useSelector } from 'react-redux';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';

import { WantMoreSubscriptions } from '~/src/features/full-buy/containers/pages/Subscriptions/WantMoreSubscriptions';
import { RequiredAndSelectivelySubscriptionsContainer, SubscriptionsContainer } from '~/src/features/full-buy/containers/Subscriptions';
import { getRequiredAndSelectivelySubscriptions } from '~/src/features/full-buy/store/selectors/getRequiredAndSelectivelySubscriptions';

import * as S from '~/src/features/full-buy/containers/pages/styled';

const subscriptionPlural = getPluralize(['подписку', 'подписки', 'подписок']);

const CombinedContainerForMainPage = (): JSX.Element | null => {
    const {
        subscriptions,
        needToSelect,
    } = useSelector(getRequiredAndSelectivelySubscriptions);

    if (needToSelect.oneOf === 0 && needToSelect.multiple === 0) {
        return null;
    }

    return <S.BlocksWrapper>
        {subscriptions.oneOf.length > 0
            ? (
                <RequiredAndSelectivelySubscriptionsContainer/>
            )
            : (
                <>
                    <TextWrapper $lastIndent={false}>
                        <H3>Выберите {needToSelect.multiple + needToSelect.oneOf} {subscriptionPlural(needToSelect.multiple + needToSelect.oneOf)}</H3>
                        <WantMoreSubscriptions/>
                    </TextWrapper>

                    <SubscriptionsContainer/>
                </>
            )
        }
    </S.BlocksWrapper>;
};

export default CombinedContainerForMainPage;
